import ResourceNav from '../view/ResourceCenter/ResourceNav'
import Log from '../view/log'

import YqInformation from '../view/ResourceCenter/YqInformation/YqInformation'
import ModifyYqInformation from '../view/ResourceCenter/YqInformation/ModifyYqInformation'

import YqNoticeManagement from '../view/ResourceCenter/YqNoticeManagement/YqNoticeManagement'
import AddYqNotice from '../view/ResourceCenter/YqNoticeManagement/AddYqNotice'
import ModifyYqNotice from '../view/ResourceCenter/YqNoticeManagement/ModifyYqNotice'

import ParkVideoManagement from '../view/ResourceCenter/ParkVideoManagement/ParkVideoManagement'
import AddParkVideo from '../view/ResourceCenter/ParkVideoManagement/AddParkVideo'
import ModifyParkVideo from '../view/ResourceCenter/ParkVideoManagement/ModifyParkVideo'

import PartyInformationManage from '../view/ResourceCenter/PoliticalParty/PartyInformation/PartyInformationManage'
import AddPartyInformation from '../view/ResourceCenter/PoliticalParty/PartyInformation/AddPartyInformation'
import ModifyPartyInformation from '../view/ResourceCenter/PoliticalParty/PartyInformation/ModifyPartyInformation'

import PartyPolicyManage from '../view/ResourceCenter/PoliticalParty/PartyPolicy/PartyPolicyManage'
import AddPartyPolicy from '../view/ResourceCenter/PoliticalParty/PartyPolicy/AddPartyPolicy'
import ModifyPartyPolicy from '../view/ResourceCenter/PoliticalParty/PartyPolicy/ModifyPartyPolicy'

// 住户管理
import BusinessManagement from '../view/ResourceCenter/BusinessManagement/BusinessManagement'
import BusinessAdd from '../view/ResourceCenter/BusinessManagement/BusinessAdd'
import BusinessModify from '../view/ResourceCenter/BusinessManagement/BusinessModify'
import BusinessCurrent from '../view/ResourceCenter/BusinessManagement/BusinessCurrent'

// 人员管理
import PersonManagement from '../view/ResourceCenter/PersonManagement/PersonManagement'
import PersonAdd from '../view/ResourceCenter/PersonManagement/PersonAdd'
import PersonCurrent from '../view/ResourceCenter/PersonManagement/PersonCurrent'
import PersonModify from '../view/ResourceCenter/PersonManagement/PersonModify'
import LesseeManage from '../view/ResourceCenter/LesseeManage/LesseeManage'
import LesseeAdd from '../view/ResourceCenter/LesseeManage/LesseeAdd'
import LesseeCurrent from '../view/ResourceCenter/LesseeManage/LesseeCurrent'
import LesseeModify from '../view/ResourceCenter/LesseeManage/LesseeModify'

import AccountManagement from '../view/ResourceCenter/AccountManagement/AccountManagement'
import AccountAdd from '../view/ResourceCenter/AccountManagement/AccountAdd'
import AccountModify from '../view/ResourceCenter/AccountManagement/AccountModify'

import RoleManagement from '../view/ResourceCenter/RoleManagement/RoleManagement'
import RoleAdd from '../view/ResourceCenter/RoleManagement/RoleAdd'
import RoleModify from '../view/ResourceCenter/RoleManagement/RoleModify'

import ConfigAli from '../view/ResourceCenter/ConfigurationManagement/ConfigAli/ConfigAli'
import AliAdd from '../view/ResourceCenter/ConfigurationManagement/ConfigAli/AliAdd'
import AliCurrent from '../view/ResourceCenter/ConfigurationManagement/ConfigAli/AliCurrent'
import AliModify from '../view/ResourceCenter/ConfigurationManagement/ConfigAli/AliModify'

import ConfigWx from '../view/ResourceCenter/ConfigurationManagement/ConfigWx/ConfigWx'
import WxAdd from '../view/ResourceCenter/ConfigurationManagement/ConfigWx/WxAdd'
import WxCurrent from '../view/ResourceCenter/ConfigurationManagement/ConfigWx/WxCurrent'
import WxModify from '../view/ResourceCenter/ConfigurationManagement/ConfigWx/WxModify'

import ConfigCardType from '../view/ResourceCenter/ConfigurationManagement/ConfigCardType/ConfigCardType'

import ConfigCard from '../view/ResourceCenter/ConfigurationManagement/ConfigCard/ConfigCard'
import ConfigCardWx from '../view/ResourceCenter/ConfigurationManagement/ConfigCard/ConfigCardWx'

import ConfigRoutine from '../view/ResourceCenter/ConfigurationManagement/ConfigRoutine/ConfigRoutine'
import ModifyRoutine from '../view/ResourceCenter/ConfigurationManagement/ConfigRoutine/ModifyRoutine'
import checkIn from '../view/ResourceCenter/PersonManagement/personCheckIn'

// 配置管理
import configManagement from '../view/ResourceCenter/configManagement/MessagePush/configManagement'
import configModify from '../view/ResourceCenter/configManagement/MessagePush/configModify'
import BannerManage from '../view/ResourceCenter/configManagement/BannerConfig/BannerManage'
import BannerAdd from '../view/ResourceCenter/configManagement/BannerConfig/BannerAdd'
import BannerModify from '../view/ResourceCenter/configManagement/BannerConfig/BannerModify'
import ApprovalManage from '../view/ResourceCenter/configManagement/ApprovalConfig/ApprovalManage'
import ApprovalModify from '../view/ResourceCenter/configManagement/ApprovalConfig/ApprovalModify'
import NavigationBarConfig from '../view/ResourceCenter/configManagement/NavigationBarConfig/NavigationBarConfig'
import BossBulletinBoard from '../view/ResourceCenter/configManagement/BossBulletinBoard/BossBulletinBoard'
import BossBulletinBoardAdd from '../view/ResourceCenter/configManagement/BossBulletinBoard/BossBulletinBoardAdd'
import FaceAuthorizationConfig from '../view/ResourceCenter/configManagement/FaceAuthorizationConfig/FaceAuthorizationConfig'

// import LeaseNav from '../view/LeaseCenter/LeaseNav'
import HousingManagement from '../view/ResourceCenter/HousingManagement/HousingManagement'
import HousingAdd from '../view/ResourceCenter/HousingManagement/HousingAdd'
import HousingModify from '../view/ResourceCenter/HousingManagement/HousingModify'
import HousingBuildingAdd from '../view/ResourceCenter/HousingManagement/HousingBuildingAdd'
import HousingBuildingModify from '../view/ResourceCenter/HousingManagement/HousingBuildingModify'

export default [
  {
    path: '/yq_information',
    name: 'yq-information',
    components: {
      default: ResourceNav,
      a: YqInformation
    }
  },
  {
    path: '/modify_yq_information',
    name: 'modify-yq-information',
    components: {
      default: ResourceNav,
      a: ModifyYqInformation
    }
  },

  {
    path: '/yq_notice_management',
    name: 'yq-notice-management',
    components: {
      default: ResourceNav,
      a: YqNoticeManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/add_notice_yq',
    name: 'add-yq-notice',
    components: {
      default: ResourceNav,
      a: AddYqNotice
    }
  },
  {
    path: '/modify_yq_notice/:id',
    name: 'modify-yq-notice',
    components: {
      default: ResourceNav,
      a: ModifyYqNotice
    }
  },
  {
    path: '/party_information_manage',
    name: 'party-information-manage',
    components: {
      default: ResourceNav,
      a: PartyInformationManage
    }
  },
  {
    path: '/party_information_add',
    name: 'party-information-add',
    components: {
      default: ResourceNav,
      a: AddPartyInformation
    }
  },
  {
    path: '/party_information_modify/:id',
    name: 'party-information-modify',
    components: {
      default: ResourceNav,
      a: ModifyPartyInformation
    }
  },
  {
    path: '/party_policy_manage',
    name: 'party-policy-manage',
    components: {
      default: ResourceNav,
      a: PartyPolicyManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/party_policy_add',
    name: 'party-policy-add',
    components: {
      default: ResourceNav,
      a: AddPartyPolicy
    }
  },
  {
    path: '/party_policy_modify/:id',
    name: 'party-policy-modify',
    components: {
      default: ResourceNav,
      a: ModifyPartyPolicy
    }
  },

  {
    path: '/park_video_management',
    name: 'park-video-management',
    components: {
      default: ResourceNav,
      a: ParkVideoManagement
    }
  },
  {
    path: '/add_video_park',
    name: 'add-park-video',
    components: {
      default: ResourceNav,
      a: AddParkVideo
    }
  },
  {
    path: '/modify_park_video/:id',
    name: 'modify-park-video',
    components: {
      default: ResourceNav,
      a: ModifyParkVideo
    }
  },

  /* 资源中心 ———— 人员管理 */
  {
    path: '/person_management',
    name: 'person-management',
    components: {
      default: ResourceNav,
      a: PersonManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/person_add',
    name: 'person-add',
    components: {
      default: ResourceNav,
      a: PersonAdd
    }
  },
  {
    path: '/person_modify/:id',
    name: 'person-modify',
    components: {
      default: ResourceNav,
      a: PersonModify
    }
  },
  {
    path: '/person_check_in',
    name: 'person-check-in',
    components: {
      default: ResourceNav,
      a: checkIn
    }
  },
  {
    path: '/person_current/:id',
    name: 'person-current',
    components: {
      default: ResourceNav,
      a: PersonCurrent
    }
  },
  {
    path: '/lessee_management',
    name: 'lessee-management',
    components: {
      default: ResourceNav,
      a: LesseeManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/lessee_add',
    name: 'lessee-add',
    components: {
      default: ResourceNav,
      a: LesseeAdd
    }
  },
  {
    path: '/lessee_modify/:id',
    name: 'lessee-modify',
    components: {
      default: ResourceNav,
      a: LesseeModify
    }
  },
  {
    path: '/lessee_current/:id',
    name: 'lessee-current',
    components: {
      default: ResourceNav,
      a: LesseeCurrent
    }
  },
  /* 资源中心 ———— 人员管理 */

  /* 资源中心 ———— 子账号管理 */
  {
    path: '/account_management',
    name: 'account-management',
    components: {
      default: ResourceNav,
      a: AccountManagement
    }
  },
  {
    path: '/account_add',
    name: 'account-add',
    components: {
      default: ResourceNav,
      a: AccountAdd
    }
  },
  {
    path: '/account_modify/:id',
    name: 'account-modify',
    components: {
      default: ResourceNav,
      a: AccountModify
    }
  },
  /* 资源中心 ———— 子账号管理 */

  /* 资源中心 ———— 角色管理 */
  {
    path: '/role_management',
    name: 'role-management',
    components: {
      default: ResourceNav,
      a: RoleManagement
    }
  },
  {
    path: '/role_add',
    name: 'role-add',
    components: {
      default: ResourceNav,
      a: RoleAdd
    }
  },
  {
    path: '/role_modify/:id',
    name: 'role-modify',
    components: {
      default: ResourceNav,
      a: RoleModify
    }
  },
  /* 资源中心 ———— 角色管理 */

  /* 资源中心 ———— 配置管理 */
  {
    path: '/banner_manage',
    name: 'banner-manage',
    components: {
      default: ResourceNav,
      a: BannerManage
    }
  },
  {
    path: '/banner_add',
    name: 'banner-add',
    components: {
      default: ResourceNav,
      a: BannerAdd
    }
  },
  {
    path: '/banner_modify/:id',
    name: 'banner-modify',
    components: {
      default: ResourceNav,
      a: BannerModify
    }
  },
  {
    path: '/resource_approval_manage',
    name: 'resource-approval-manage',
    components: {
      default: ResourceNav,
      a: ApprovalManage
    }
  },
  {
    path: '/resource_approval_modify/:id',
    name: 'resource-approval-modify',
    components: {
      default: ResourceNav,
      a: ApprovalModify
    }
  },
  {
    path: '/navigation_bar_config',
    name: 'navigation-bar-config',
    components: {
      default: ResourceNav,
      a: NavigationBarConfig
    }
  },
  {
    path: '/boss_bulletin_board',
    name: 'boss-bulletin-board',
    components: {
      default: ResourceNav,
      a: BossBulletinBoard
    }
  },
  {
    path: '/face_authorization_config',
    name: 'face-authorization-config',
    components: {
      default: ResourceNav,
      a: FaceAuthorizationConfig
    }
  },
  {
    path: '/boss_bulletin_board/add',
    name: 'boss-bulletin-board-add',
    components: {
      default: ResourceNav,
      a: BossBulletinBoardAdd
    }
  },
  {
    path: '/ali_config',
    name: 'ali-config',
    components: {
      default: ResourceNav,
      a: ConfigAli
    }
  },
  {
    path: '/ali_add',
    name: 'ali-add',
    components: {
      default: ResourceNav,
      a: AliAdd
    }
  },
  {
    path: '/ali_config/current/:id',
    name: 'ali-current',
    components: {
      default: ResourceNav,
      a: AliCurrent
    }
  },
  {
    path: '/ali_config/modify/:id',
    name: 'ali-modify',
    components: {
      default: ResourceNav,
      a: AliModify
    }
  },
  {
    path: '/wx_config',
    name: 'wx-config',
    components: {
      default: ResourceNav,
      a: ConfigWx
    }
  },
  {
    path: '/wx_add',
    name: 'wx-add',
    components: {
      default: ResourceNav,
      a: WxAdd
    }
  },
  {
    path: '/wx_config/current/:id',
    name: 'wx-current',
    components: {
      default: ResourceNav,
      a: WxCurrent
    }
  },
  {
    path: '/wx_config/modify/:id',
    name: 'wx-modify',
    components: {
      default: ResourceNav,
      a: WxModify
    }
  },
  {
    path: '/config_card',
    name: 'config-card',
    components: {
      default: ResourceNav,
      a: ConfigCard
    }
  },
  {
    path: '/config_card_wx',
    name: 'config-card-wx',
    components: {
      default: ResourceNav,
      a: ConfigCardWx
    }
  },
  {
    path: '/config_card_type',
    name: 'config-card-type',
    components: {
      default: ResourceNav,
      a: ConfigCardType
    }
  },
  {
    path: '/config_routine',
    name: 'config-routine',
    components: {
      default: ResourceNav,
      a: ConfigRoutine
    }
  },
  {
    path: '/modify_routine',
    name: 'modify-routine',
    components: {
      default: ResourceNav,
      a: ModifyRoutine
    }
  },
  /* 资源中心 ———— 配置管理 */

  /* 住户租赁 ———— 房屋管理 */
  {
    path: '/housing_management',
    name: 'housing-management',
    components: {
      default: ResourceNav,
      a: HousingManagement
    }
  },
  {
    path: '/housing_add',
    name: 'housing-add',
    components: {
      default: ResourceNav,
      a: HousingAdd
    }
  },
  {
    path: '/housing_modify/:id',
    name: 'housing-modify',
    components: {
      default: ResourceNav,
      a: HousingModify
    }
  },
  {
    path: '/housing_building_add',
    name: 'housing-building-add',
    components: {
      default: ResourceNav,
      a: HousingBuildingAdd
    }
  },
  {
    path: '/housing_building_modify/:id',
    name: 'housing-building-modify',
    components: {
      default: ResourceNav,
      a: HousingBuildingModify
    }
  },
  /* 住户租赁 ———— 房屋管理 */

  /* 住户租赁 ———— 住户管理 */
  {
    path: '/business_management',
    name: 'business-management',
    components: {
      default: ResourceNav,
      a: BusinessManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/business_add',
    name: 'business-add',
    components: {
      default: ResourceNav,
      a: BusinessAdd
    }
  },
  {
    path: '/business_modify/:id',
    name: 'business-modify',
    components: {
      default: ResourceNav,
      a: BusinessModify
    }
  },
  {
    path: '/business_current/:id',
    name: 'business-current',
    components: {
      default: ResourceNav,
      a: BusinessCurrent
    }
  },
  /* 住户租赁 ———— 住户管理 */
  // 资源中心操作日志
  {
    path: '/resource_center_log',
    name: 'resource-center-log',
    components: {
      default: ResourceNav,
      a: Log
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/ResourceCenter.js